export const PHONE_REGEX = /^(0)?[1,2,3,7,8][0-9]{9}$/;
